<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <h3 class="mt-3">
      {{ $getVisibleNames("mesh.cycle", true, "Ciclos Formativos") }}
      <AlternativeNameButton
        :table_name="'mesh.cycle'"
        :allows_crud="allows_crud"
      ></AlternativeNameButton>
    </h3>
    <div style="display: flex">
      <div class="col" style="text-align: left">
        <ButtonMedium
          v-can="'mesh.add_cycle'"
          v-if="allows_crud"
          :tooltip_text="
            $t('reusable.common.addTooltip', {
              entity: $getVisibleNames('mesh.cycle', false, 'Ciclo Formativo'),
            })
          "
          :text_button="$t('reusable.common.add')"
          v-b-modal.new-cycle-modal
          :icon="'plus'"
          :variant="'primary'"
        >
        </ButtonMedium>
      </div>
    </div>
    <GenericBTable
      v-if="!isBusy"
      :items="cycles"
      :pagination="cycles.length"
      :fields="fields"
      :filter="input_search"
      stacked="md"
      :show_pagination="true"
      :search_filter="true"
      :columns_display="true"
      :allows_crud="allows_crud"
      :display_id="display_id"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <!-- <template #cell(init_semester)="row">
        <span v-b-tooltip.v-secondary="'Semestre inicial'">{{
          row.item.init_semester
        }}</span>
      </template>
      <template #cell(end_semester)="row">
        <span v-b-tooltip.v-secondary="'Semestre final'">{{
          row.item.end_semester
        }}</span>
      </template> -->
      <template #cell(institution)="row">
        <div v-if="row.item.institution">SI</div>
        <div v-else>NO</div>
      </template>
      <template #cell(egress_profiles)="row">
        <b-button
          variant="none"
          :id="`popover-button-variant-${row.item.id}`"
          v-b-tooltip.v-secondary.hover="$t('reusable.common.viewDetails')"
        >
          <b-icon icon="eye" scale="1"></b-icon>
        </b-button>
        <b-popover
          :target="`popover-button-variant-${row.item.id}`"
          triggers="focus"
        >
          <template #title>
            {{
              $getVisibleNames("mesh.egressprofile", true, "Perfiles De Egreso")
            }}
            <!-- Perfiles de Egreso -->
          </template>
          <div
            v-for="(egress_profiles, index) in [getEgressProfiles(row.item.id)]"
            :key="index"
          >
            <!-- v-for="egress_profile in egressProfiles.filter(
                (x) => x.id == egress_profile_id
              )" -->

            <template v-for="profile in egress_profiles">
              <div :key="profile.id" class="profiles-container">
                <b-button
                  variant="none"
                  @click="redirectToEgressProfile(profile.id)"
                  class="profiles mb-1"
                  v-b-tooltip.v-secondary="
                    $t('curricularDefinitions.cycle.goToProfile')
                  "
                >
                  {{ profile.professional_title }}
                </b-button>
              </div>
            </template>
          </div>
        </b-popover>
      </template>
      <template #cell(description)="row">
        <RenderVHtml :content="row.item.description"></RenderVHtml>
      </template>
      <template v-if="allows_crud" #cell(actions)="row">
        <ButtonSmall
          :tooltip_text="
            $t('reusable.common.editTooltip', {
              entity: $getVisibleNames('mesh.cycle', false, 'Ciclo Formativo'),
            })
          "
          :click_button="() => $bvModal.show(`edit-cycle-modal-${row.item.id}`)"
          :class="``"
          :icon="'square'"
        ></ButtonSmall>
        <ButtonSmall
          :click_button="() => askForDeleteCycle(row.item.id)"
          :tooltip_text="
            $t('reusable.common.deleteTooltip', {
              entity: $getVisibleNames('mesh.cycle', false, 'Ciclo Formativo'),
            })
          "
          :icon="'trash'"
        ></ButtonSmall>
        <b-modal
          :id="`edit-cycle-modal-${row.item.id}`"
          :title="
            $t('reusable.common.editModalTitle', {
              entity: $getVisibleNames('mesh.cycle', false, 'Ciclo Formativo'),
            })
          "
          size="xl"
          hide-footer
        >
          <CyclesForm
            :Cycle="row.item"
            @updated="slotUpdatedCycle"
            :show_title="false"
          ></CyclesForm>
        </b-modal>
      </template>
    </GenericBTable>
    <div>
      <b-modal
        id="new-cycle-modal"
        :title="
          $t('reusable.common.createModalTitle', {
            entity: $getVisibleNames('mesh.cycle', false, 'Ciclo Formativo'),
          })
        "
        size="xl"
        hide-footer
      >
        <CyclesForm
          @created="slotCreatedCycle"
          :show_title="false"
        ></CyclesForm>
      </b-modal>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";
export default {
  name: "CyclesListView",
  components: {
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    CyclesForm: () => import("./CyclesForm.vue"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {
    input_search: {
      type: String,
      default: "",
    },
    display_id: {},
  },
  data() {
    return {
      loading: 0,
      sortBy: "",
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      egressProfiles: names.EGRESS_PROFILES,
      profileCycles: names.PROFILE_CYCLES,
      careers: names.CAREERS,
      faculties: names.FACULTIES,
      cycles: names.CYCLES,
    }),
    breadcrumb_items() {
      return [
        {
          text: this.$t("reusable.breadcrumb.home"),
          to: "/home",
        },
        {
          text: this.$getVisibleNames("mesh.cycle", true, "Ciclos Formativos"),
        },
      ];
    },
    allows_crud() {
      if (
        this.user.group_names.includes(
          "DIRECTIVOS ACADÉMICOS INSTITUCIONALES"
        ) ||
        this.user.is_superuser
      ) {
        const has_permission = this.$hasPermissions("mesh.add_cycle");
        if (has_permission) return has_permission;
        else return false;
      } else return false;
    },
    isBusy() {
      if (this.loading != 0) return true;
      return false;
    },
    fields() {
      return [
        {
          key: "name",
          label: this.$getVisibleNames("mesh.cycle", true, "Ciclos Formativos"),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        // {
        //   key: "init_semester",
        //   label: "Inicio",
        //   sortable: true,
        // },
        // {
        //   key: "end_semester",
        //   label: "Fin",
        //   sortable: true,
        // },
        {
          key: "description",
          label: this.$t("reusable.common.description"),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "certification",
          label: this.$t("curricularDefinitions.cycle.certification"),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "institution",
          label: this.$t("curricularDefinitions.cycle.institutional"),
          sortable: true,
          display_column: true,
        },
        {
          key: "egress_profiles",
          label: this.$t("curricularDefinitions.cycle.profiles"),
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    getEgressProfiles(cycle_id) {
      let list = [];
      const profile_cycles = this.profileCycles.filter(
        (x) => x.cycle == cycle_id
      );
      profile_cycles.forEach((profile_cycle) => {
        const egress_profile = this.egressProfiles.find(
          (x) => x.id == profile_cycle.egress_profile
        );
        const index = list.findIndex(
          (x) => x.id == profile_cycle.egress_profile
        );
        if (egress_profile && index == -1) list.push(egress_profile);
      });
      return list;
    },
    slotCreatedCycle() {
      this.$bvModal.hide("new-cycle-modal");
    },
    slotUpdatedCycle(cycle) {
      this.$bvModal.hide(`edit-cycle-modal-${cycle.id}`);
    },
    askForDeleteCycle(cycle_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames("mesh.cycle", false, "Ciclo Formativo"),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(names.DELETE_CYCLE, cycle_id).then(() => {
            toast(
              this.$getVisibleNames("mesh.cycle", false, "Ciclo Formativo") +
                " " +
                this.$t("curricularDefinitions.cycle.deletedMale")
            );
          });
        }
      });
    },
    redirectToEgressProfile(id) {
      // let route_data = this.$router.resolve({
      this.$router.push({
        name: "EgressProfileView",
        params: { egress_profile_id: id },
      });
      // window.open(route_data.href, "_blank");
    },
  },
  mounted() {},
  created() {
    this.loading = 1;
    // Antes pedía la carrera de cada perfil de egreso uno por uno (sin
    // ningún guard): con varios perfiles compartiendo carrera, eran N GET
    // individuales. Un solo FETCH_CAREERS cubre todas de una.
    this.$store.dispatch(names.FETCH_EGRESS_PROFILES);
    this.$store.dispatch(names.FETCH_CAREERS);
    this.$store.dispatch(names.FETCH_FACULTIES);
    this.$store.dispatch(names.FETCH_CAMPUSES);
    this.$store.dispatch(names.FETCH_CYCLES);
    this.$store.dispatch(names.FETCH_PROFILE_CYCLES).then(() => {
      this.loading -= 1;
    });
  },
};
</script>

<style scoped>
.add-icon {
  margin-right: -2%;
  font-size: bold;
}
.profiles-container {
  width: 100%;
}
.profiles {
  background-color: var(--secondary-color);
  border-radius: 4px;
  padding: 0 2em;
  width: 100%;
  font-size: 11pt;
  text-align: center;
}
</style>